'use client';

import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

export default function HotjarInit() {
  useEffect(() => {
    hotjar.initialize({
      id: 5191187,
      sv: 6
    })
  }, []);

  return <></>
}
